<template>
  <div class="hostel-report-wrapper">
    <!-- Summary Bar -->
    <div v-if="startDate" class="mb-3">
      <div class="card border-0 bg-light">
        <div class="card-body py-2 px-3">
          <div class="summary-bar">
            <div class="summary-event-info">
              <strong>{{ eventInfo ? eventInfo.name : '' }}</strong>
              <span class="text-muted ml-2" v-if="eventInfo && eventInfo.default_start_time">
                {{ eventInfo.default_start_time }} – {{ eventInfo.default_end_time }}
              </span>
            </div>
            <div class="summary-period">
              <span class="text-muted">Period:</span>
              <strong>{{ startDate }} – {{ endDate }}</strong>
              <span class="ml-2 text-muted" v-if="totalDays">({{ totalDays }} days)</span>
            </div>
            <div class="summary-tags">
              <a-tag>Students: {{ data.length }}</a-tag>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Report Table -->
    <a-table
      :columns="columns"
      :dataSource="data"
      :rowKey="record => record.student_id"
      :loading="loading"
      :pagination="{ pageSize: 50, showSizeChanger: true, pageSizeOptions: ['25', '50', '100'] }"
      :scroll="{ x: 'max-content' }"
      size="middle"
      bordered
    >
      <template slot="index" slot-scope="text, record, index">
        {{ index + 1 }}
      </template>

      <template slot="student" slot-scope="text, record">
        <div>
          <strong>{{ record.student.first_name }} {{ record.student.last_name }}</strong>
          <br>
          <small class="text-muted">{{ record.student.student_code }}</small>
        </div>
      </template>

      <template slot="hostel" slot-scope="text, record">
        {{ record.hostel ? record.hostel.name : '-' }}
      </template>

      <template slot="block" slot-scope="text, record">
        {{ record.block ? record.block.name : '-' }}
      </template>

      <template slot="room" slot-scope="text, record">
        {{ record.room ? record.room.room_number : '-' }}
      </template>

      <template slot="class" slot-scope="text, record">
        <span v-if="record.class_section && record.class_section.school_class">
          {{ record.class_section.school_class.name }}
        </span>
        <span v-else>-</span>
      </template>

      <template slot="section" slot-scope="text, record">
        <span v-if="record.class_section && record.class_section.section">
          {{ record.class_section.section.name }}
        </span>
        <span v-else>-</span>
      </template>

      <template slot="present" slot-scope="text, record">
        <span class="text-success font-weight-bold">{{ record.present }}</span>
      </template>

      <template slot="absent" slot-scope="text, record">
        <span class="text-danger font-weight-bold">{{ record.absent }}</span>
      </template>

      <template slot="pending" slot-scope="text, record">
        <span class="text-warning font-weight-bold">{{ record.pending }}</span>
      </template>

      <template slot="percentage" slot-scope="text, record">
        <a-progress
          :percent="record.percentage"
          :strokeColor="record.percentage >= 75 ? '#52c41a' : record.percentage >= 50 ? '#faad14' : '#f5222d'"
          :format="p => p + '%'"
          size="small"
          style="width: 100px"
        />
      </template>
    </a-table>
  </div>
</template>

<script>
const columns = [
  { title: '#', key: 'index', scopedSlots: { customRender: 'index' }, width: 50 },
  { title: 'Student', key: 'student', scopedSlots: { customRender: 'student' }, width: 160 },
  { title: 'Hostel', key: 'hostel', scopedSlots: { customRender: 'hostel' }, width: 130 },
  { title: 'Block', key: 'block', scopedSlots: { customRender: 'block' }, width: 100 },
  { title: 'Room', key: 'room', scopedSlots: { customRender: 'room' }, width: 80 },
  { title: 'Class', key: 'class', scopedSlots: { customRender: 'class' }, width: 90 },
  { title: 'Section', key: 'section', scopedSlots: { customRender: 'section' }, width: 90 },
  { title: 'Total', dataIndex: 'total_days', key: 'total_days', width: 70, align: 'center' },
  { title: 'Present', key: 'present', scopedSlots: { customRender: 'present' }, width: 80, align: 'center' },
  { title: 'Absent', key: 'absent', scopedSlots: { customRender: 'absent' }, width: 80, align: 'center' },
  { title: 'Pending', key: 'pending', scopedSlots: { customRender: 'pending' }, width: 80, align: 'center' },
  { title: 'Attendance %', key: 'percentage', scopedSlots: { customRender: 'percentage' }, width: 140 },
]

export default {
  name: 'HostelAttendanceReportTable',
  props: {
    loading: { type: Boolean, default: false },
    data: { type: Array, default: () => [] },
    eventInfo: { type: Object, default: null },
    startDate: { type: String, default: '' },
    endDate: { type: String, default: '' },
    totalDays: { type: Number, default: 0 },
  },
  data() {
    return { columns }
  },
}
</script>

<style scoped>
.summary-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.summary-event-info {
  flex: 1 1 auto;
  min-width: 0;
}

.summary-period {
  flex: 0 0 auto;
}

.summary-tags {
  flex: 0 0 auto;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

@media (max-width: 768px) {
  .summary-bar {
    flex-direction: column;
    align-items: flex-start;
  }

  .summary-tags {
    width: 100%;
  }
}
</style>
